import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Load Typeform embed script
const tfScript = document.createElement('script');
tfScript.src = '//embed.typeform.com/next/embed.js';
tfScript.async = true;
document.head.appendChild(tfScript);
render(<App data-id="element-170" />, document.getElementById('root'));